var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode"},[_c('div',{staticClass:"barcode__image",style:({ backgroundImage: `url('${_vm.image}')` })}),_c('span',{staticClass:"barcode__label",domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }